<template>
    <div class="user-account-container inner-padding-sm scroll" :class="{ 'selected': is_selected  && multiple }" @click="toggleAccount">
        <div>
            <i class="fa fa-check-square m-r-5" style="color:#26a2d9" v-if="is_selected"></i>
            <i class="fa fa-square-o m-r-5" v-else></i>
        </div>
        <button class="btn btn-xs btn-success pull-right text-uppercase" style="width:93px;" v-if="is_default">
            Default
        </button>
        <button class="btn btn-xs btn-orange pull-right text-uppercase" @click.stop="setDefault" v-else>
            Make Default
        </button>
        <div class="">
            <span class="m-r-5 text-bold" >#{{ account_nbr }}</span>
            <span class="" :class="{ 'text-bold':is_selected }">{{ account_nm }}</span>
            <span class="city-state" :class="{ 'text-bold':is_selected }">({{ city }}, {{ state_cd }})</span>
        </div>
        <div class="text-sm">
            {{ role_label }}
        </div>
    </div>
</template>

<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .user-account-container {
        cursor: default;

        &:not(:last-child) {
            border-bottom: 1px solid $border-gray;

            &.selected {
              //  border-bottom: 1px solid darken($light-blue, 18%);
            }
        }

        &.selected {
           // background-color: #eaf7e8;
            background-color: #d9e6f7;
        }
        &:hover {
            background : darken(#d9e6f7, 5%);
        }

        > * {
            display: inline-block;

            &.label {
                width: 90px;
                text-align: center;

                &.change-default-account {
                    &:hover,&:focus {
                        cursor: pointer;
                        color: #dfdfdf;
                    }
                }
            }

            .account-number {
                width: 75px;
            }

            .city-state {
                font-weight: normal;
                font-size: 12px;
            }
        }
    }
</style>

<script>
    module.exports = {
        props: {
            account_nbr: { default: null },
            account_nm: { default: null },
            city: { default: null },
            state_cd: { default: null },
            role_label: { default: null },
            is_default: { default: null },
            index: { default: null },
            multiple: { default: function() { return this.$parent.multiple; } },
            is_selected: { default: false }
        },

        data: function() {
            return {

            }
        },

        methods: {
            toggleAccount: function() {
                if (this.is_selected) {
                    this.removeAccount();
                }
                else {
                    this.selectAccount();
                }
            },

            selectAccount: function() {
                this.$emit('select',this.index);
            },

            removeAccount: function() {
                this.$emit('remove',this.index);
            },

            setDefault: function() {
                this.$emit('default',this.index);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// account-list-item.vue?44290598